import * as React from 'react'
import { ProgressIndicator } from "@fluentui/react";

interface IMessageProgressBar {
  message?: string;
}

export const ProgressBarLoading = (props: IMessageProgressBar) => {
  return (
      <ProgressIndicator description={props.message ?? "Cargando..."} barHeight={3} />
  );
}